module.exports = __webpack_public_path__ + "static/media/17.78d50bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/17.png
// module id = 654
// module chunks = 0